export * from './baFileUploader.component';



// WEBPACK FOOTER //
// /app/src/app/theme/components/baFileUploader/index.ts